export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'accreditation',
                    modifier: (value, row) => {
                        let data;
                        if (value) {
                            data = value.record;
                        } else {
                            data = row.evaluation.accreditation != null ? row.evaluation.accreditation.record : '';
                        }
                        return data; 
                    }
                },
                {
                    title: this.$t('area'),
                    type: 'custom-html',
                    key: 'accreditation',
                    modifier: (value, row) => {
                        let data;
                        if (value) {
                            data = value.accreditation_area.name;
                        } else {
                            data = row.evaluation.accreditation != null ? row.evaluation.accreditation.accreditation_area.name : '';
                        }
                        return data; 
                    }
                },
                {
                    title: this.$t('activity'),
                    type: 'custom-html',
                    key: 'accreditation',
                    modifier: (value, row) => {
                        let data;
                        if (value) {
                            data = value.accreditation_activity.name;
                        } else {
                            data = row.evaluation.accreditation != null ? row.evaluation.accreditation.accreditation_activity.name : '';
                        }
                        return data; 
                    }
                },
                {
                    title: this.$t('type'),
                    type: 'custom-html',
                    key: 'accreditation',
                    modifier: (value, row) => {
                        let data;
                        if (value) {
                            data = value.accreditation_type.name;
                        } else {
                            data = row.evaluation.accreditation.accreditation_type.name;
                        }
                        return data; 
                    }
                    
                },
                {
                    title: 'Proceso en',
                    type: 'custom-html',
                    key: '',
                    key: 'accreditation',
                    modifier: (value, row) => {
                        let data;
                        let evalt;
                        if (value) {
                            data = `<span class="badge badge-sm badge-pill badge-primary">Solicitud</span>`;;
                        } else {
                            evalt = row.evaluation.type;
                            if (evalt == "E") {
                                data = `<span class="badge badge-sm badge-pill badge-primary">Evaluación</span>`;; 
                            } else if (evalt == "T") {
                                data = `<span class="badge badge-sm badge-pill badge-primary">Testificación</span>`;;
                            }
                        }
                        return data; 
                    }
                },
                {
                    title: 'Organización',
                    type: 'custom-html',
                    key: 'accreditation',
                    modifier: (value, row) => {
                        let data;
                        if (value) {
                            data = value.organization?value.organization.business_name:'';
                        } else {
                            data = row.evaluation.accreditation.organization?row.evaluation.accreditation.organization.business_name:'';
                        }
                        return data; 
                    }
                },
                {
                    title: this.$t('status'),
                    type: 'custom-html',
                    key: 'status',
                    modifier: (value, row) => {
                        let data;
                        if (value) {
                            data = value.name;
                            let d = row.days * (-1);
                            let bname;
                            if (d > 0 && d <= 2) {
                                bname = 'testp3';
                            } else if (d > 2 && d <=7) {
                                bname = 'testp2';
                            } else {
                                bname = 'testp1';
                            }
                            return `<span class="badge badge-sm badge-pill badge-${bname}">${data}</span>`; 
                        } 
                    }
                },
                {
                    title: this.$t('Días de demora'),
                    type: 'custom-html',
                    key: 'days',
                    modifier: (value) => {
                        if (value) {
                            let d = value * (-1);
                            let bname;
                            if (d > 0 && d <= 2) {
                                bname = 'testp3';
                            } else if (d > 2 && d <=7) {
                                bname = 'testp2';
                            } else {
                                bname = 'testp1';
                            }

                            return `<span class="badge badge-sm badge-pill badge-${bname}">${d}</span>`; 
                        } 
                    }
                },
            ],
            
        }
    },
}